function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import styled from "styled-components";
import forwardRef from "../../../private/forwardRef";
import { nanoid } from "nanoid/non-secure";
var StyledSVG = styled.svg.withConfig({
  displayName: "FacebookLg__StyledSVG",
  componentId: "sc-1cll7ju-0"
})(["width:1.5rem;height:1.5rem;"]);
var FacebookLg = forwardRef(function (props, ref) {
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(StyledSVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": props != null && props.title ? titleId : undefined
  }, props), (props == null ? void 0 : props.title) && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, props.title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.934 13.165.551-3.592H14.04V7.242c0-.983.481-1.941 2.025-1.941h1.567V2.243S16.21 2 14.85 2c-2.838 0-4.694 1.72-4.694 4.835v2.738H7v3.592h3.155v8.684a12.517 12.517 0 0 0 3.884 0v-8.684h2.896Z",
    fill: "currentColor"
  }));
});
FacebookLg.displayName = "FacebookLg";
export default FacebookLg;